const css = `.MKFvLG__chartDot{transition:transform .1s}.MKFvLG__fillDefault{fill:var(--base-surfaces-default)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"fillDefault":"MKFvLG__fillDefault","chartDot":"MKFvLG__chartDot"};
